export const SET_STATUS_DETAILS_CACHED = "@@cached/SET_STATUS_DETAILS_CACHED";

export function setSiteDetailsCached(details) {
  return async (dispatch) => {
    dispatch({
      type: SET_STATUS_DETAILS_CACHED,
      payload: details,
    });
  };
}

export const SET_USER_CACHED = "@@cached/SET_USER_CACHED";

export function setUserCached(user) {
  return async (dispatch) => {
    dispatch({
      type: SET_USER_CACHED,
      payload: user,
    });
  };
}

export const GET_USER_CACHED = "@@cached/GET_USER_CACHED";

export function getUserCached(id) {
  return (_dispatch, getState) => {
    if (!id) return null;
    const { cached } = getState();
    return cached.users.find((user) => user.id === id) || null;
  };
}
